// import React, { useCallback } from "react";

import { useMutation } from "@apollo/react-hooks";

import { gql } from "apollo-boost";

const mutation = gql`
  mutation userUpdate(
    $name: String!
    $email: String!
    $cic: String
    $phone: String
  ) {
    updateUser(name: $name, email: $email, cic: $cic, phone: $phone) {
      email
      cic
      name
      photo
      phone
    }
  }
`;

export const useUpdate = () => {
  return useMutation(mutation);
};
